"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GwsGameProvidersListCtl = /** @class */ (function (_super) {
    __extends(GwsGameProvidersListCtl, _super);
    function GwsGameProvidersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_imported_games_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.imported_games_count; });
        _this.dk_admin_allowed_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_allowed_count; });
        _this.dk_zones_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.zones_count; });
        _this._errDialog = errDialog;
        return _this;
    }
    GwsGameProvidersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    GwsGameProvidersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    GwsGameProvidersListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListGwsGameProvidersGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    is_deprecated: resp.list[i].is_deprecated,
                    is_locked: resp.list[i].is_locked,
                    imported_games_count: resp.list[i].games_imported_cnt,
                    admin_allowed_count: resp.list[i].admins_allowed_cnt,
                    zones_count: resp.list[i].zones_cnt
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddGwsGameProvider.exec({
            data: {
                title: data.title,
                description: data.description,
                is_deprecated: data.is_deprecated,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                description: data.description,
                is_deprecated: data.is_deprecated,
                is_locked: data.is_locked,
                imported_games_count: 0,
                admin_allowed_count: 0,
                zones_count: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditGwsGameProvider.exec({
                data: {
                    gws_gameprovider_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_deprecated: data.is_deprecated,
                    is_locked: data.is_locked,
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.description = data.description;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_locked = data.is_locked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GwsGameProvidersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteGwsGameProvider.exec({ data: { gws_gameprovider_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersListCtl.prototype.SetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderIsDeprecated.exec({ data: { gws_gameprovider_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersListCtl.prototype.CheckIntegration = function (key, onDone) {
        var _this = this;
        webAApi_1.DoCheckGwsGameProviderConnection.exec({ data: { gws_gameprovider_id: key } }, function (resp) {
            if (onDone) {
                onDone(resp.is_ok, resp.games_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersListCtl.prototype.ClearGames = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoClearGwsGameProviderGames.exec({ data: { gws_gameprovider_id: key } }, function (resp) {
                _tmp.imported_games_count = 0;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersListCtl.prototype.ImportGames = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoImportGwsGameProviderGames.exec({ data: { gws_gameprovider_id: key } }, function (resp) {
                _tmp.imported_games_count = resp.games_added + resp.games_updated;
                _this.Update();
                if (onDone) {
                    onDone(resp.games_added, resp.games_updated);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GwsGameProvidersListCtl;
}(BaseController_1.BaseController));
exports.GwsGameProvidersListCtl = GwsGameProvidersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ctl/GwsGameProvidersListCtl.ts
// module id = 864
// module chunks = 0